export const pathNamePages = {
  home: "/",
  inicio: "/inicio",
  ventasProducto: "/ventasProducto",
  ventasTipoPago: "/ventasTipoPago"
};
